import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DropzoneConfigInterface } from 'angular2-dropzone-wrapper';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { FileService } from '../../services/file.service';
import { saveAs as importedSaveAs } from "file-saver";
import { FileNamePipe } from '../../pipes/file-name.pipe';
import { CompanyService } from '../../services/company.service';
import { Title } from '@angular/platform-browser';
import { Company } from '../../classes/company';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-upload-documents-page',
  templateUrl: './upload-documents-page.component.html',
  styleUrls: ['./upload-documents-page.component.scss']
})
export class UploadDocumentsPageComponent implements OnInit {


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private FileService: FileService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private titleService: Title,
    private CompanyService: CompanyService,
    private UserService: UserService
  ) { }

  getConfig(fileType: string, mimeTypes: string = '') {
    let config: DropzoneConfigInterface = {
      dictDefaultMessage: `
        <div style='margin-top: -22px'>
          <p style='color: #b4b4b4; font-size: 17pt'>Drag completed file here or</p>
          <a style="border: 1px solid #b4b4b4;
            border-radius: 20px;
            background: transparent;
            color: black;
            padding: 10px 20px;
            font-size: 11px;
            text-decoration: none;
            display: inline-block">
              <b>SELECT FILE</b>
            </a>
        </div>`,
      dictFallbackMessage: '',
      server: `${environment.organizationsUrl}/${this.orgId}/documents/upload_file`,
      headers: {
        Authorization: `Bearer ${localStorage.onboardingToken}`,
      },
      maxFilesize: 20,
      acceptedFiles: mimeTypes ? mimeTypes : 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain',
      paramName: 'file',
      params: `file_type=${fileType}`,
    }
    return config;
  }

  businessConsentConfig: DropzoneConfigInterface;
  remittanceConfig: DropzoneConfigInterface;
  voidCheckConfig: DropzoneConfigInterface;
  reg1Config: DropzoneConfigInterface;
  reg2Config: DropzoneConfigInterface;
  uploaded: any = <any>{};
  allUploaded: boolean = false;
  businessConsentFormUrl = environment.businessConsentFormUrl;
  remittanceVerificationUrl = environment.remittanceVerificationUrl;
  sub: any;
  fileSub: any;
  orgId: number;
  files: any;
  error: string;
  incomplete: boolean;
  company: Company = <Company>{};
  name: string = '';
  state: any = <any>{};
  steps: any[] = [];
  missingSteps: boolean;
  focusConsent: boolean = false;
  openConsent: boolean = false;
  focusRemittance: boolean = false;
  openRemittance: boolean = false;
  focusVoidCheque: boolean = false;
  openVoidCheque: boolean = false;
  focusReg1: boolean = false;
  focusReg2: boolean = false;
  openReg1: boolean = false;
  openReg2: boolean = false;
  isAdmin: boolean = false;

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      let errId: number = +params['errId'];
      if (errId == 1) {
        this.error = 'You cannot go to next step until all files are uploaded.'
      }
      this.businessConsentConfig = this.getConfig('business_consent_form');
      this.remittanceConfig = this.getConfig('remittance_verification');
      this.voidCheckConfig = this.getConfig('void_cheque', 'application/pdf, image/jpeg, image/png');
      this.reg1Config = this.getConfig('payroll_register_one', 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, text/csv');
      this.reg2Config = this.getConfig('payroll_register_two', 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, text/csv');
      this.getFiles(this.orgId);
      this.getCompany(this.orgId);
    });
    this.titleService.setTitle('Upload Documents');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCompany(orgId: number) {
    this.CompanyService.getCompany(orgId)
      .subscribe(company => {
        this.company = JSON.parse(company.organization);
        this.steps = JSON.parse(company.steps);
        this.missingSteps = this.steps.slice(0, 3)
          .filter(s => {
            return !s[2];
          }).length > 0;
        this.incomplete = this.steps.slice(0, 3).some(s => {
          return !s[2];
        })

        this.UserService.getUserInfo()
          .subscribe(user => {
            console.log(user)
            let u: any = JSON.parse(user.user);
            this.isAdmin = u.admin;
            if (!this.isAdmin && this.incomplete) {
              this.router.navigate(['/onboarding/payrollschedule/', this.orgId, 1])
            }
          }, err => {
            console.log(err)
            if (err.status == 401) {
              localStorage.clear();
              this.router.navigate(['/']);
            }
          })

        this.state = JSON.parse(company.state);
      })
  }

  getFiles(orgId: number) {
    this.FileService.getFiles(orgId)
      .subscribe(files => {
        this.files = JSON.parse(files.document || '{}');
        this.allUploaded = !!(this.files.business_consent_form &&
          this.files.remittance_verification &&
          this.files.void_cheque)
        this.ChangeDetectorRef.detectChanges();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  onUploadError(e: any, type: string) {
    console.log(e);
    this.getFiles(this.orgId);
    if(!this.isAdmin) window.analytics.track("Self-Signup "+ type + " Upload Failed", {OrgId: this.orgId, docType: type, reason: e});
  }

  onUploadSuccess(e: any, type: string) {
    console.log(e);
    if(!this.isAdmin) window.analytics.track("Self-Signup "+ type + " Uploaded", {OrgId: this.orgId, docType: type});
    this.getFiles(this.orgId);
  }

  onCancel(e: any, type: string) {
    console.log(e);
    this.getFiles(this.orgId);
  }

  next() {
    console.log(this.allUploaded)
    if (this.allUploaded) {
      this.router.navigate(['/onboarding/timeoff', this.orgId]);
    }
    else {
      this.missingSteps = this.steps
        .filter(s => {
          return !s[2] && s[0] != 'Upload Documents' && s[0] != 'Setup your Vacation Policies';
        }).length > 0;

      let steps = this.steps
        .filter(s => {
          return !s[2] && s[0] != 'Upload Documents' && s[0] != 'Setup your Vacation Policies';
        }).map(s => {
          return s[0]
        }).join(', ');
      if (this.missingSteps) {
        this.error = `Upload failed. Please complete the following steps before uploading: ${steps}`;
      }
      else {
        this.error = 'All files must be uploaded.';
      }

    }
  }

  downloadFile(type: string, path: string) {
    this.FileService.downloadFile(this.orgId, type)
      .subscribe(blob => {
        let fileName = path;
        console.log(blob)
        importedSaveAs(new Blob([blob]), fileName);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  deleteFile(type: string) {
    this.FileService.deleteFile(this.orgId, type)
      .subscribe(res => {
        this.getFiles(this.orgId);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  onClickedOutside(e: any) {
    console.log('Clicked outside:', e);
    if (e.target.className != 'fa fa-question-circle-o') {
      this.openReg1 = false;
      this.openReg2 = false;
      this.openVoidCheque = false;
      this.openRemittance = false;
      this.openConsent = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/upload-documents-page/upload-documents-page.component.ts